import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";

const Chapter29 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);

    return (
        <>
                 {/* Chapter 29 */}
                <section id="section29" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">{language.chapter29Title}</h2>

                    <h3 className="drivers-handbook-subheading">{language.chapter29Subheading1}</h3>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter29Paragraph1}
                    </p>
                    <p className="drivers-handbook-paragraph">
                       {language.chapter29Paragraph2}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter29Paragraph3}

                    </p>
                    <p className="drivers-handbook-paragraph">
                       {language.chapter29Paragraph4}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter29Paragraph5}
                    </p>


                </section>

        </>
    )

}

export default Chapter29;
